import * as React from "react";
import { useEffect } from "react";
import { useLocation } from "react-router";
import { useSaveConversationInStorage } from "../solverHooks/saveConversation";

//region [[ Props ]]

export interface SessionRestoreProps {
  sessionId?: string;
  embedded: boolean;
  children?: React.ReactNode;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const SessionRestore = ({
  sessionId,
  embedded,
  ...props
}: SessionRestoreProps) => {
  const saveConversationInStorage = useSaveConversationInStorage();

  const location = useLocation();

  useEffect(() => {
    if (embedded)
      sessionStorage.setItem(
        (sessionId || "") + "location",
        JSON.stringify(location),
      );
  }, [sessionId, embedded, location]);

  useEffect(() => {
    // Used to be implemented only for embedded, keep state now for defualt
    // if (embedded)
    saveConversationInStorage(sessionId);
  }, [/*embedded, */ sessionId, saveConversationInStorage]);

  return <>{props.children}</>;
};
